import styled from 'styled-components';
import { navy, primary, surface, shadowSoft, radiusLg, bgApp } from '../../../Layout/Resources/Theme'

const Box = styled.div`
  background-color: ${bgApp};
  background-image: linear-gradient(145deg, #F4F6F8 0%, #FFFFFF 45%, rgba(255, 21, 42, 0.06) 100%);
  display: flex;
  align-items: center;
  height: 100vh;
  width: 100%;
  padding: 48px;
  justify-content: center;

  @media (max-width: 768px) {
    padding: 16px;
  }
`

Box.Container = styled.div`
  max-width: 420px;
  width: 100%;
`

Box.Content = styled.div`
  border-radius: ${radiusLg};
  padding: 36px 32px;
  background: ${surface};
  box-shadow: ${shadowSoft};
  border: 1px solid #E5E7EB;
  animation: sp-fade-up 0.32s ease both;

  @media (max-width: 768px) {
    padding: 28px 20px;
  }
`

Box.Logo = styled.img`
  max-width: 200px;
  height: auto;
`

Box.Title = styled.h1`
  font-size: 1.35rem;
  font-weight: 700;
  color: ${navy};
  margin: 12px 0 4px;
`

Box.Subtitle = styled.p`
  font-size: 0.88rem;
  color: #6B7280;
  margin: 0 0 8px;
`

Box.Accent = styled.div`
  width: 48px;
  height: 4px;
  border-radius: 999px;
  background: ${primary};
  margin: 0 auto 20px;
`

export default Box
